
      import { FolkShape } from '@folkjs/labs/standalone/folk-shape';
      import { hitDetection } from '@folkjs/geometry/Rect2D';

      const shapes = Array.from(document.querySelectorAll('folk-shape, p'));

      const getBoundingBox = (el) => (el instanceof FolkShape ? el.getTransformDOMRect() : el.getBoundingClientRect());

      function handleCollision(e) {
        for (const shape of shapes) {
          if (shape === e.target) continue;

          const hit = hitDetection(getBoundingBox(e.target), getBoundingBox(shape));

          if (hit === null) continue;

          if (shape instanceof FolkShape) {
            if (hit.delta.x !== 0) shape.x += hit.delta.x;
            if (hit.delta.y !== 0) shape.y += hit.delta.y;
          } else {
            if (hit.delta.x !== 0) e.preventX();
            if (hit.delta.y !== 0) e.preventY();
          }
        }
      }

      document.addEventListener('transform', handleCollision);
    